import React, { useEffect, useState, Suspense } from "react";
import ememi from "../../../assets/icons/emami.svg";
import tamam from "../../../assets/icons/coin-farapic-01.png";
const Chart = React.lazy(() => import("../../../shared/chart"));

const CoinItems = ({ items, showSidbarMarginLeft }) => {
  const [archiveCurrencyState, setArchiveCurrencyState] = useState();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/getArchiveForCoinChart`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        id: items.id,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setArchiveCurrencyState(data.data);
      })
      .catch((err) => console.log(err));
  }, [items.id]);

  return (
    <div
      style={{ direction: "rtl" }}
      className="w-[90%] rounded-3xl p-4  bg-white text-[#444] font-semibold shadow-3xlSlate screen500:p-2"
    >
      <div className=" flex flex-row  mx-auto w-full justify-between my-auto ">
        <div className="flex flex-row   ">
          <div className={`mx-auto my-auto h-20 screen500:h-16   `}>
            <img
              alt="سکه"
              src={`${items.id === 1 || items.id === 6 ? ememi : tamam}`}
              className={`
              ${
                (items.id === 1 || items.id === 6) &&
                "my-auto  mx-auto  w-20 h-20  screen1200:w-14 screen1200:h-14 screen1200:mt-3  screen700:w-10 screen700:h-10 screen700:mt-5 screen500:mt-3   "
              }  
              ${
                items.id === 2 &&
                "my-auto  mx-auto  w-20 h-20  screen1200:w-14 screen1200:h-14 screen1200:mt-3  screen700:w-10 screen700:h-10 screen700:mt-5 screen500:mt-3 "
              }  
              ${
                (items.id === 3 || items.id === 7) &&
                "w-14 h-14  mx-auto mt-3  screen1200:w-10 screen1200:h-10 screen1200:mt-5 screen700:w-7 screen700:h-7 screen700:mt-6  screen500:mt-4"
              }  
              ${
                (items.id === 4 || items.id === 8) &&
                "w-12 h-12  mx-auto mt-4 screen1200:w-8 screen1200:h-8 screen1200:mt-6 screen700:w-6 screen700:h-6 screen700:mt-7 screen500:mt-5 "
              }  
              ${
                items.id === 5 &&
                "w-10 h-10  mx-auto mt-5  screen1200:w-7 screen1200:h-7 screen1200:mt-6 screen700:w-5 screen700:h-5 screen700:mt-7 screen500:mt-5"
              }  
              `}
            />
          </div>
          <div className="text-sm my-auto ">
            <div className="mr-2 screen700:mr-1">
              <div
                className={`w-[140%]  ${
                  items.id === 1 &&
                  !showSidbarMarginLeft &&
                  "screen370:text-[12px]"
                }
              
              ${showSidbarMarginLeft ? "text-[9px]" : "screen500:text-[13px]"}
              `}
              >
                {items.Coin.name}
              </div>
            </div>
          </div>
        </div>
        <div className=" h-fit my-auto ">
          <Suspense
          // fallback={
          //   <div className="animate-pulse mx-auto w-full">
          //     در حال بارگذاری...
          //   </div>
          // }
          >
            <Chart data={archiveCurrencyState} />
          </Suspense>
        </div>
      </div>

      <div className=" screen700:px-3 screen500:px-3">
        <div className="flex flex-row justify-between">
          <span
            className={` my-auto 
              ${showSidbarMarginLeft ? "text-[9px]" : "screen500:text-[11px]"}
          
          `}
          >
            خرید
          </span>
          <span
            className={` 
              ${showSidbarMarginLeft ? "text-[9px]" : "screen500:text-[14px]"}
          
          `}
          >
            {items.buyPrice.toLocaleString()}
          </span>
        </div>
        <div className="flex flex-row justify-between">
          <span
            className={`
            my-auto 
          ${showSidbarMarginLeft ? "text-[9px]" : "screen500:text-[11px]"}
         `}
          >
            فروش
          </span>
          <span
            className={`
            my-auto 
          ${showSidbarMarginLeft ? "text-[9px]" : "screen500:text-[11px]"}
         `}
          >
            {items.sellPrice.toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CoinItems;
